export default __webpack_public_path__ + "static/media/contact.13139676.jpg";